import React from 'react';
import { Button, SparkIcon } from '@spark';
import { buildTaskSelectOptions, buildVersionSelectOptions } from './eligibleTrainings';
import { FieldHint, LabeledDropdown, SectionTitle } from './fields';

/**
 * "Model" section: one row per selected task with Select Task / Select
 * Version dropdowns. The first row carries the Add Task button (Triton flows
 * only — a vLLM image serves one model); later rows get a Remove button.
 */
export default function TaskSelectionRows({
  selectedTasks,
  trainingsPool,
  mode,
  canAddTask,
  addTaskDisabled,
  onAddTask,
  onTaskSelect,
  onVersionSelect,
  onRemoveTask,
}) {
  return (
    <section className="configure-deployment-modal__section" aria-label="Model">
      <SectionTitle>Model</SectionTitle>
      <div className="configure-deployment-modal__task-rows">
        {selectedTasks.map((entry, index) => {
          const usecaseId = entry.training.llm_usecase_id;
          const isFirstRow = index === 0;
          const taskOptions = buildTaskSelectOptions(trainingsPool, mode, selectedTasks, usecaseId);
          const versionOptions = buildVersionSelectOptions(
            trainingsPool,
            mode,
            usecaseId,
            entry.training.version
          );
          return (
            <div key={entry.taskKey} className="configure-deployment-modal__task-row">
              <LabeledDropdown
                className="configure-deployment-modal__task-field"
                label="Select Task"
                options={taskOptions}
                value={usecaseId}
                onChange={(value) => onTaskSelect(entry.taskKey, value)}
                searchable
              />
              <LabeledDropdown
                className="configure-deployment-modal__task-field configure-deployment-modal__task-field--version"
                label="Select Version"
                options={versionOptions}
                value={entry.training.version}
                onChange={(value) => onVersionSelect(entry.taskKey, value, usecaseId)}
              />
              <div className="configure-deployment-modal__task-action">
                {isFirstRow ? (
                  canAddTask ? (
                    <Button
                      variant="secondary"
                      startIcon={<SparkIcon slug="plus" size="small" />}
                      disabled={addTaskDisabled}
                      onClick={onAddTask}
                    >
                      Add Task
                    </Button>
                  ) : null
                ) : (
                  <Button
                    variant="ghost"
                    icon={<SparkIcon slug="close" size="small" />}
                    aria-label="Remove task"
                    onClick={() => onRemoveTask(entry.taskKey)}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      {canAddTask ? <FieldHint>Only one version per task can be selected.</FieldHint> : null}
    </section>
  );
}
